export enum VirtualSportQueryKeys {
  List = "virtualSport.list",
  Single = "virtualSport.single",
  Rounds = "virtualSport.rounds",
  Timing = "virtualSport.timing",
  Standings = "virtualSport.standings",
  Results = "virtualSport.results",
}
